import { CreateAllRewardUser, CreateRewardUser, CreateStakingUser, CreateUnstakinguser } from '@/types';
import { axiosPost } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';

// 스테이킹
export const stakingUsers = async (aData: CreateStakingUser, isAlert: boolean = true) => {
  const payload = {
    apiUrl: process.env.REACT_API_ASSET_API_URL!,
    path: '/v1/staking-users',
    body: { ...aData },
  };
  return sendRequest(payload, 'stakingUsers', axiosPost, false, isAlert);
};
// 언스테이킹, 회수
export const unstakingUsers = async (aData: CreateUnstakinguser, isAlert: boolean = true) => {
  const payload = {
    path: '/v1/staking-users/unstake',
    body: { ...aData },
  };
  return sendRequest(payload, 'unstakingUsers', axiosPost, false, isAlert);
};
// 특정 리워드 받기
export const claimRewardUsers = async (aData: CreateRewardUser, isAlert: boolean = false) => {
  const payload = {
    path: '/v1/staking-user-reward',
    body: { ...aData },
  };
  return sendRequest(payload, 'claimRewardUsers', axiosPost, false, isAlert);
};

// 특정 리워드 전부 받기(db와 컨트랙트간의 데이터가 맞지 않을 경우, 회수 전 자동 실행)
export const claimAllRewardUsers = async (aData: CreateAllRewardUser, isAlert: boolean = false) => {
  const payload = {
    path: '/v1/staking-user-reward/all',
    body: { ...aData },
  };
  return sendRequest(payload, 'claimAllRewardUsers', axiosPost, false, isAlert);
};
